export enum DisciplineEvaluationDeliverableTypeEnum {
  PRACTICE_ACTIVITY = 'PRACTICE_ACTIVITY',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  REVIEW_LIST = 'REVIEW_LIST',
  THINK_AND_ANSWER = 'THINK_AND_ANSWER',
  OBJECTIVE_TRIVIA = 'OBJECTIVE_TRIVIA',
}

export interface DisciplineEvaluationDeliverable {
  order: number;
  positions: number[];
  type: DisciplineEvaluationDeliverableTypeEnum;
  weight: number;
}

export interface DisciplineEvaluationModel {
  achievementWeight: number;
  deliverables: DisciplineEvaluationDeliverable[];
}

export interface DisciplineExercisesDeadline {
  firstDueDate: string;
  secondDueDate: string;
}

export interface DisciplineEvaluationAndDeadlines {
  disciplineInstanceId: string;
  evaluationModel: DisciplineEvaluationModel;
  exercisesDeadlines: DisciplineExercisesDeadline;
  grade: number;
}
